// 请保证所有语言包 的Key值都一直
export default {
  login: {
    username: "Tên tài khoản",
    password: "Mật khẩu",
  },
  menu: {
    Menu_ItemList: "Danh sách dự án",
    Menu_ToDoList: "Danh sách chờ xử lý",
    Menu_Drafts: "Hộp nháp",
  },
  common: {
    close: "Đóng",
    add: "Thêm",
    confirm: "Xác nhận",
    delete: "Xóa",
    uploadOnlyOne: "Chỉ được tải lên một tệp",
    ploadExcelFormat: "Vui lòng tải lên tệp Excel (.xls hoặc .xlsx)!",
    uploadMaxSize: "Kích thước tệp tải lên không được vượt quá 30MB!",
    welcome: "Xin chào",
    upload: "Tải lên",
    download: "Tải xuống",
    save: "Lưu",
    saveDraft: "Lưu bản nháp",
    submit: "Nộp",
    view: "Xem",
    edit: "Biên tập",
    search: "Tìm kiếm",
    reset: "Thiết lập lại",
    export: "Xuất ra",
    discard: "Hủy bỏ",
    audit: "Thẩm định",
    preReturnBtn: "Trở lại",
    uploadtip: "Tối đa 30M",
    downloadTemplate: "Tải mẫu",
  },
  message: {
    level2Required: "Vui lòng chọn đối tác cấp hai",
    unbound:
      "Tài khoản của bạn KHÔNG được liên kết với hợp đồng đối tác hợp lệ. Vui lòng đảm bảo rằng hợp đồng đối tác vẫn còn hiệu lực và tài khoản đã được liên kết. Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với bộ phận bán hàng của Ruijie.",
    prompt: "Vui lòng nhập ít nhất hai ký tự.",
    registrationNo: "Nhập số đăng ký.",
    hints:
      "Nếu dự án bị trượt hoặc không cần tiếp tục bảo vệ, vui lòng nhấp vào loại bỏ dự án",
    deleteConfirm: "Xác nhận xóa?",
    discardConfirm: "Xác nhận loại bỏ?",
    cancel: "Hủy bỏ",
    comfirm: "Xác nhận",
    deletesuccess: "Xóa thành công",
    operation: "Thao tác",
    setDepartment: "Vui lòng liên hệ bộ phận quản trị cài đặt",
    queryResult: "Kết quả tìm kiếm",
    needPartnerName: "Vui lòng nhập tên đối tác ",
    needProjectName: "Vui lòng nhập tên dự án",
    needRuijieSaleName1: "Vui lòng nhập tên phụ trách kinh doanh của Ruijie",
    needCountry: "Vui lòng nhập tên quốc gia của dự án",
    needFinalCompanyName: "Vui lòng nhập tên công ty của người dùng cuối ",
    needFinalCompanyAddress:
      "Vui lòng nhập địa chỉ công ty của người dùng cuối ",
    needFinalUserName:
      "Vui lòng nhập tên phụ trách quản lý dự án của người dùng cuối ",
    needFinalUserPosition:
      "Vui lòng nhập tên chức vụ của phụ trách quản lý dự án của người dùng cuối",
    needFinalUserTel: "Vui lòng nhập số điện thoại của người ra quyết định ",
    needFinalUserEmail:
      "Vui lòng nhập vào địa chỉ email của người ra quyết định ",
    needFundsInPlace:
      "Vui lòng cho biết kinh phí của dự án đã được duyệt chưa:",
    needProjectBudget: "Vui lòng cho biết tổng dự toán của toàn dự án",
    needNetworkBudget: "Vui lòng cho biết dự toán của phần Mạng",
    needPurchaseTime: "Vui lòng cho biết thời gian dự định mua hàng",
    needExpectedOrderDate: "Vui lòng cho biết thời gian dự định đặt hàng",
    needIsSupportRuijie:
      "Vui lòng cho biết phụ trách dự án của người dùng cuối có ủng hộ sản phẩm Ruijie hay không",
    needHasCooperated:
      "Vui lòng cho biết trước đây đã có hợp tác với người dùng cuối chưa",
    needRuijieSaleName: "Vui lòng chọn tên phụ trách kinh doanh của Ruijie",
    needProjectRequirements: "Vui lòng cho biết yêu cầu của dự án",
    needEmail: "Vui lòng nhập vào địa chỉ email",
    needBeEmail: "Vui lòng nhập đúng định dạng email",
    needPartnerEmail: "Vui lòng nhập email của người phụ trách của đối tác",
    needPartnerContactName: "Vui lòng nhập tên người liên hệ của dối tác",
    needPartnerPhone:
      "Vui lòng nhập số điện thoại của người liên hệ của đối tác",
    needJointVisit:
      "Vui lòng chọn có thể sắp xếp buổi gặp mặt giữa Ruijie và các bên tham gia dự án hay không",
    needProjectPhase: "Vui lòng chọn giai đoạn của dự án",
    unitOfCash: "USD",
    saveSuccess: "Lưu thành công",
    submitSuccess: "Nộp thành công",
    submitError: "Nộp thất bại",
    select: "Vui lòng chọn",
    agree: "Đồng ý",
    reject: "Từ chối",
    rejectToFirst: "Từ chối về bước 1",
    needOpinion: "Vui lòng nhập lý do cần xem xét",
    needDiscardReason: "Vui lòng nhập lý do hủy bỏ",
    discardSuccess: "Hủy bỏ thành công",
    clause: "Những điều cần biết khi đăng kí dự án",
    close: "Đóng",
    readyAndAgree:
      "Tôi đã đọc và đồng ý với điều khoản bảo vệ dự án đối tác của Ruijie",
    pleaseReadAndAgreeClause:
      "Vui lòng đọc trước điều khoản bảo vệ dự án đối tác của Ruijie ",
    budgetNotAllow: "Vui lòng nhập một số dương trong vòng 12 chữ số ",
    budgetCantNegative: "Số tiền dự toán không được âm",
    needNumberType: "Vui lòng nhập loại số",
    enterProjectName: "Nhập tên dự án để tìm kiếm",
    enterFinalUserName: "Nhập tên người dùng cuối để tìm kiếm",
    enterFinalCompanyAddress: "Nhập tên công ty triển khai dự án để tìm kiếm",
    approver: "Người duyệt",
    logout: "Thoát",
    restrictionPrompt:
      "Lưu ý: Hãy sử dụng mẫu Excel được cung cấp để tải dữ liệu lên. Kích thước tệp không được vượt quá 30 MB. Hệ thống sẽ tự động nhận diện dữ liệu trong tệp, bạn có thể chỉnh sửa dữ liệu sau này.",
  },
  page: {
    drafts: "Hộp nháp",
    addProject: "Tạo dự án mới",
    exportProduct: "Xuất sản phẩm",
    uploadButtonMessage1: "Kéo tệp vào đây, hoặc",
    uploadButtonMessage2: "Nhấp để tải lên",
    list: "Danh sách dự án",
    todoList: "Danh sách chờ xử lý",
    projectSearch: "Tìm kiếm mục đăng ký",
    prmNew: {
      title: "Tạo dự án mới",
      partnerName: "Tên đối tác",
      projectName: "Tên dự án",
      country: "Dự án thuộc quốc gia",
      finalCompanyName: "Tên công ty người dùng cuối",
      finalCompanyAddress: "Địa chỉ thực hiện dự án",
      finalUserName: "Tên người phụ trách dự án của người dùng cuối",
      finalUserPosition: "Chức vụ người phụ trách dự án của người dùng cuối",
      finalUserTel:
        "Số điện thoại bàn người phụ trách dự án của người dùng cuối",
      finalUserPhone:
        "Số điện thoại di động người phụ trách dự án của người dùng cuối ",
      finalUserEmail: "E-mail của người phụ trách dự án của người dùng cuối ",
      fundsInPlace: "Kinh phí dự án đã được duyệt chưa",
      projectBudget: "Tổng dự toán của toàn dự án",
      networkBudget: "Dự toán của phần Mạng",
      expectedOrderDate: "Thời gian dự định đặt hàng",
      isSupportRuijie:
        "Phụ trách dự án của người dùng cuối có ủng hộ sản phẩm Ruijie hay không?",
      ruijieSaleName: "Phụ trách kinh doanh Ruijie",
      hasCooperated: "Đã từng hợp tác với người dùng cuối chưa?",
      projectPhase: "Dự án này ở bước nào?",
      projectPhases: "Dự án này ở bước nào?",
      expctedOrderDate: "Ngày hết hạn",
      lastUpdata: "Cập nhật dữ liệu mới nhất",
      projectRequirements: "Yêu cầu cụ thể của dự án",
      budgetFrom: "Dự toán đến từ",
      executiveDepartment: "Bộ phận nào đã hoặc sắp khởi động dự án này?",
      participatingDepartment: "Bộ phận nào đã hoặc sẽ tham gia dự án này?",
      dockingPeople:
        "Ai có thể trở thành tư vấn hoặc hỗ trợ cho chúng ta trong dự án? Lai lịch như thế nào?",
      competitorSituation: "Tình hình đối thủ cạnh tranh",
      beforeSell: "Trước đây bạn đã từng bán sản phẩm nào vào người dùng cuối",
      projectAttachment: "Danh sách sản phẩm của dự án này",
      projectAttachmentDetail: "Danh sách thiết bị dự án",
      partnerEmail: "Địa chỉ email của đối tác đăng kí dự án",
      partnerContactName: "Tên người liên hệ của đối tác đăng kí dự án",
      partnerPhone: "Số điện thoại người liên hệ của đối tác đăng kí dự án",
      projectContractor: "Tổng thầu dự án（đối với dự án ELV）",
      relatedRAP: "liên quan rap",
      jointVisit: "Có thể sắp xếp cùng đi thăm người dùng cuối hay không?",
      fillFullName: "Vui lòng điền tên đầy đủ, không viết tắt",
    },
    prmList: {
      projectStep: "Các bước dự án",
      registration: "Đăng ký",
      partnerName: "Tên đối tác",
      projectName: "Tên dự án",
      country: "Dự án thuộc quốc gia",
      ruijieSaleName: "Phụ trách kinh doanh",
      taxNumber: "Mã số thuế",
      approvalState: "Trạng thái phê duyệt",
      prmState: "Trạng thái",
      discardReason: "Nguyên nhân hủy bỏ",
      // showClause: 'Xem điều khoản đăng kí bảo vệ dự án cần biết',
      showClauseSBG: "Xem hướng dẫn của báo cáo SBG",
      showClauseEBG: "Xem hướng dẫn của báo cáo EBG",
      applicant: "Người xin phê duyệt",
      submitTime: "Thời gian nộp",
      createTime: "Ngày tạo",
      expireTime: "Ngày hết hạn",
    },
    prmDetail: {
      contentTitle: "Proje Bilgisi",
      approvalTitle: "Ghi chú phê duyệt",
      approvalNode: "Điểm phê duyệt",
      operator: "Người thao tác",
      auditStatus: "Trạng thái",
      approvalDate: "Thời gian phê duyệt",
      approvalRemarks: "Giải thích cụ thể phê duyệt",
      operatorLogTitle: "Nhật kí thao tác",
      operation: "Nội dung thao tác",
      fieldName: "Tên trường",
      oldValue: "Giá trị cũ",
      newValue: "Giá trị mới",
      updateTime: "Thời gian cập nhật",
      operationType: "Loại thao tác",
      endUserInfo: "Thông tin người dùng cuối",
      partnerInfo: "Thông tin đối tác",
    },
    prmEdit: {
      title: "Biên tập",
    },
    prmAudit: {
      title: "Phê duyệt",
      remarksApproval: "Giải thích cụ thể phê duyệt",
    },
    prmView: {
      title: "Xem",
    },
    ProjectSearch: {
      result: "Hậu quả",
      country: "Quốc gia",
      sales: "Bán hàng",
      email: "Thư điện tử",
    },
  },
};
